import React, { useEffect, useRef, useState } from "react";
import "./ProfilePopup.css";
import { Link } from "react-router-dom";
import { useAuth } from './../../../AuthProvider';
import { useApp } from './../../../AppProvider';
import Massage from '../../MassagePopUp/Massage';
import logger from "../../../utils/logger";

function ProfilePopup({ onClose }) {
  const popupRef = useRef(null);
  const { logout, switchClinic } = useAuth();
  const { clinics, selectedClinic, setSelectedClinic } = useApp();
  const [switchError, setSwitchError] = useState('');

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });


  const handleClick = async (item) => {
    if (selectedClinic._id.toString() === item._id.toString()) {
      return;
    }

    try {
      await switchClinic(item._id);
      setSelectedClinic(item);
      onClose();
    } catch (e) {
      logger.error("Error switching clinic:", e.message);
      setSwitchError("Couldn't switch clinic. Please try again.");
    }
  };

  const handleLogout = (event) => {
    logout();
  };

  return (
    <div className="profile-bg" ref={popupRef}>
      <div className="text-align">
        {clinics.map((item, index) => (
          <div className="id-Container" onClick={() => handleClick(item)} key={item._id || index}>
            <label className={`${selectedClinic?._id === item._id}`} >
              {item.name.fullName}
            </label>

            {selectedClinic?._id === item._id && (
              <p className="active-text">Active</p>
            )}
          </div>
        ))}


        <Link className="profile_link" to="/setting/doctorprofile">Profile</Link>
        <Link className="profile_link" to="/notification">Notification</Link>
        <label className="profile_link" onClick={handleLogout}>Logout</label>
      </div>
      {switchError && (
        <Massage message={switchError} clearError={() => setSwitchError('')} type="error" />
      )}
    </div>
  );
}

export default ProfilePopup;
